import { IMembershipPlan } from '@constants/types';

export const MEMBERSHIP: IMembershipPlan[] = [
  {
    label: 'Full access to our marketplace and multi-sensory editor',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'yes',
  },
  {
    label: 'Permanent physical gallery space at Art in Space (1 year)',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'paid',
    platinumFeature: '+ Priority visibility',
  },
  {
    label: 'One night event as a group exhibition MAX 3 galleries',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'paid',
    platinumFeature: '+ Solo Exhibition',
  },
  {
    label: 'Priority visibility on our marketplace landing page (7 days)',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'no',
  },
  {
    label: 'Private artroom booking (3 Sessions / 1 hour each)',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'paid',
    platinumFeature: '+ 3 Session',
  },
  {
    label: 'Marketing support - 10 social media posts / year',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'yes',
    platinumFeature: '+ 5 Posts',
  },
  {
    label: 'Marketing support - 1 dedicated Twitter space and Press Release, 1 interview',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'no',
  },
  {
    label: 'Allow list to Art In Space curated NFT drops',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'yes',
  },
  {
    label: 'Early access to new drops (1 day)',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'no',
    platinumFeature: '+ 2 Days',
  },
  {
    label: 'Free consultation on multi-sensory settings and implementation (3 artworks)',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'paid',
    platinumFeature: '+ 3 Artworks',
  },
  {
    label: '15% discount on rental space in our Dubai branch',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'no',
    platinumFeature: '+ 5%',
  },
  {
    label: '10% discount on artrooms | Digital led screens purchase',
    standard: 'yes',
    platinum: 'yes',
    nonMember: 'no',
    platinumFeature: '+ 5%',
  },
];
